import React, { useRef, useState } from "react";
import Styles from "../../Shared/sharedStyles.module.scss";
import InputField from "../../Shared/inputField/inputField";
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";
import { checkGSTIN } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function GstContact({ handleResponse, name }: any) {
  const serviceName = name.replaceAll(" ", "").toLowerCase();
  const gstNumberRef = useRef<any>("");
  const errorObject = {
    gstNumberError: false,
    financialYearError: false,
    contactInfoError: false,
    consentError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  function isValid() {
    if (checkGSTIN(gstNumberRef.current.value.trim().toUpperCase())) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      gstNumberError: true,
    }));
    return setIsDisabled(true);
  }

  function handleCheck() {
    const business_gstin_number = gstNumberRef.current.value.toUpperCase();
    const consent = isChecked === true ? "Y" : "N";

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    handleResponse({ business_gstin_number, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>
              {serviceName === "gstpan"
                ? "Business PAN Number"
                : "GSTIN Number"}
            </label>
            <InputField
              id={IdsGenerator({
                prefix: `${serviceName} popup`,
                id: "change",
                suffix: "gstin number",
              })}
              onChange={isValid}
              maxLength={serviceName === "gstpan" ? 10 : 15}
              inputRef={gstNumberRef}
              isError={error.gstNumberError}
              purpose="forGst"
            />
            {error.gstNumberError && (
              <ErrorMessage>{`Please enter a valid ${
                serviceName === "gstpan" ? "Business PAN " : "GSTIN"
              } number`}</ErrorMessage>
            )}
          </div>
          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: `${serviceName} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: `${serviceName} popup`,
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => setIsChecked(e.target.checked)}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: `${serviceName} popup`,
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GstContact;
